import { Component, OnInit, ViewChild } from '@angular/core';
import { AppComponent } from '../../app.component';
import { HubService } from '../../services/hub.service';
import { MasterSheetTableComponent } from './mastersheet-table.component';

@Component({
  selector: 'master-header',
  templateUrl: './master-header.component.html',
  styleUrls: ['./master-header.component.css'],
  providers: [HubService],
})

export class MasterHeaderComponent implements OnInit{
  rowCount: string;
  public uploadFlag: boolean = false;
  public removeFlag: boolean = false;
  @ViewChild('child', { static: true }) child:  MasterSheetTableComponent;

  headerUIDList: number[] = [];

  constructor() {}

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
  }

  exportLeadsCSV(): void{
      this.child.exportLeadsCSV();
  }

  receiveCount($event: string) {
    this.rowCount = $event
  }

  receiveUIDList($event: any) {
    this.headerUIDList = $event
  }

  getColor(toggle: boolean): any {
    if (toggle == true) {
      return '#c2185b';
    } else {
      return '#DDD';
    }
  }

  displayUpload(): void {
    this.uploadFlag = !this.uploadFlag;
    this.removeFlag = false;
  }

  receiveFlag($event: any) {
    this.uploadFlag = $event;
    this.removeFlag = $event;
    this.child.initalizeFromParent();
  }

}
